// extracted by mini-css-extract-plugin
module.exports = {"container":"CoverImage__container__b29eh","disabled":"CoverImage__disabled__28b27","tint":"CoverImage__tint__3lYq_","content":"CoverImage__content__2GoEc"};